import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'
import LoginView from '../views/LoginView.vue'
import MensaView from '../views/MensaView.vue'
import Mealplanning from "../components/Mealplanning.vue"

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MainView
  },
  {
    path: '/cards',
    name: 'Karten',
    component: MainView
  },
  {
    path: '/mealplanning',
    name: 'Essensplanung',
    component: MainView
  },
  {
    path: '/mealplanningframe',
    name: 'EssensplanungFrame',
    component: Mealplanning
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/mensa/monte',
    name: 'mensamonte',
    component: MensaView
  },
  {
    path: '/mensa/erft',
    name: 'mensaerft',
    component: MensaView
  },
  {
    path: '/mensa/gugy',
    name: 'mensagugy',
    component: MensaView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
